<template>
  <div>
    <!-- 인쇄용 2줄 -->
    <div v-if="web_view !== true">
      <div class="d-lg-flex justify-content-between">
        <section
          v-for="topic_type in report_topic_types"
          :key="topic_type.id"
          class="content-section"
          style="min-width: 49%"
        >
          <!-- Universal Disclosures -->
          <div v-if="topic_type.topic_type_e === 'Universal Disclosures'">
            <div v-for="category in report_universal_categories" :key="category.category_id">
              <div class="pb-1 my-2" :style="main_color">
                GRI - {{ category.category_id }}
                {{ lang !== 'ENG' ? '일반 공개사항' : 'General Disclosures' }}
              </div>

              <div
                v-for="(subtopic, index) in getUniqueSubtopicsByCategoryIds(category.category_id)"
                :key="subtopic.subtopic_code"
                class="pb-1 border-bottom"
              >
                {{ index + 1 }}.
                {{ lang != 'ENG' ? subtopic.subtopic_name : subtopic.subtopic_name_e }}
              </div>

              <hr class="border-0" />
            </div>
          </div>

          <!-- topic Specific Disclosures -->
          <div v-else>
            <div v-for="category in report_topic_specific_categories" :key="category.category_id">
              <div class="pb-1 my-2" :style="main_color">
                GRI {{ lang != 'ENG' ? category.category_name : category.category_name_e }}
              </div>

              <div
                v-for="topic in getUniqueTopicsByCategoryIds(category.category_id)"
                :key="topic.id"
                class="pb-1 border-bottom"
              >
                {{ topic.topic_id }} : {{ lang == 'ENG' ? topic.topic_name_e : topic.topic_name }}
                <MaterialityBadge
                  v-if="
                    material_topic_selected_list &&
                    material_topic_selected_list.includes(topic.topic_id)
                  "
                />
              </div>

              <hr class="border-0" />
            </div>
          </div>
        </section>
      </div>

      <div class="text-right">
        <b-badge variant="advance" class="ml-1"> M </b-badge>
        <span>: {{ lang !== 'ENG' ? '중요주제 (Material Topic)' : 'Material Topic' }}</span>
      </div>
    </div>

    <!-- 웹용 4줄 -->
    <div v-else>
      <div class="mb-5"></div>

      <b-row v-if="show_gri_table">
        <!-- GRI 100 -->
        <b-col cols="3" class="custom-col">
          <h6
            class="pl-2 py-1 mb-3 text-white cursor"
            :style="main_bg_color"
            @click="navAnchor('#rp2')"
          >
            Universal Standards
          </h6>
          <div
            v-for="category in report_universal_categories"
            :key="category.category_id"
            class="mb-3"
          >
            <h6 class="pb-1 py-2 cursor" @click="navAnchor('#rp' + category.category_id)">
              GRI - {{ category.category_id }}
              {{ lang != 'ENG' ? category.category_name : category.category_name_e }}
            </h6>
            <div>
              <div
                v-for="(subtopic, index) in getUniqueSubtopicsByCategoryIds(category.category_id)"
                :key="subtopic.subtopic_code"
                class="pb-1 border-bottom fw-300 cursor hover-gray"
                @click="navAnchor('#rp' + subtopic.subtopic_code)"
              >
                {{ index + 1 }}.
                {{ lang !== 'ENG' ? subtopic.subtopic_name : subtopic.subtopic_name_e }}
              </div>
            </div>
          </div>
        </b-col>

        <!-- GRI 100 ~ 400 -->
        <b-col cols="9">
          <h6
            class="pl-2 py-1 mb-3 text-white cursor"
            :style="main_bg_color"
            @click="navAnchor('#rp200')"
          >
            Topic Standards Disclosures
          </h6>

          <template v-if="report_topic_specific_categories.length > 0">
            <b-row>
              <b-col
                v-for="category in report_topic_specific_categories"
                :key="category.category_id"
                class="content-section-compact-sub mb-3 custom-col"
                cols="4"
              >
                <h6 class="pb-1 my-2 cursor" @click="navAnchor('#rp' + category.category_id)">
                  GRI Topic -
                  {{ lang !== 'ENG' ? category.category_name : category.category_name_e }}
                </h6>

                <div
                  v-for="topic in getUniqueTopicsByCategoryIds(category.category_id)"
                  :key="topic.id"
                  class="pb-1 border-bottom fw-300 f-95 cursor hover-gray"
                  @click="navAnchor('#trp' + topic.topic_id)"
                >
                  {{ topic.topic_id }} : {{ lang == 'ENG' ? topic.topic_name_e : topic.topic_name }}
                  <MaterialityBadge
                    v-if="
                      material_topic_selected_list &&
                      material_topic_selected_list.includes(topic.topic_id)
                    "
                  />
                </div>
              </b-col>
            </b-row>
          </template>

          <template v-else>
            <b-skeleton class="mt-4 mb-3" width="50%" />
            <b-skeleton class="mb-2" />
            <b-skeleton class="mb-2" />
            <b-skeleton class="mt-5 mb-3" width="50%" />
            <b-skeleton class="mb-2" />
            <b-skeleton class="mb-2" />
          </template>
        </b-col>
      </b-row>

      <div
        v-if="report_topic_specific_categories.length > 0 && show_gri_table"
        class="f-95 text-right"
      >
        <b-badge> M </b-badge>
        <span>: {{ lang !== 'ENG' ? '중요주제 (Material Topic)' : 'Material Topic' }}</span>
      </div>

      <div v-if="$route.hash" class="mt-5">
        <b-button @click="navAnchor(null)">
          <b-icon-menu-button-fill /> {{ lang !== 'ENG' ? '전체보기' : 'Show All' }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import * as ih from '@/components/util';
import MaterialityBadge from './MaterialityBadge';

export default {
  name: 'ContentsListBasicSkChemical',
  components: {
    MaterialityBadge
  },
  props: {
    web_view: {
      type: Boolean,
      default: false
    },
    show_gri_table: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('report_list', ['lang']),
    ...mapState('gri2021_report_view', ['report_structure', 'material_topic_selected_list']),
    ...mapGetters('report_list', ['selected_report']),
    ...mapGetters('gri2021_report_view', [
      'report_topic_specific_categories',
      'report_universal_categories',
      'report_topic_types'
    ]),
    main_color() {
      return `color:` + this.selected_report.main_color;
    },
    main_bg_color() {
      if (this.selected_report) {
        return `background-color: ` + this.selected_report.main_color;
      } else return `background-color: #494949`;
    }
  },
  methods: {
    getUniqueSubtopicsByCategoryIds(category_id) {
      const filtered_structure = this.report_structure.filter(
        item => item.category_id == category_id
      );
      const unique_subtopics = [];
      filtered_structure.forEach(item => {
        if (
          unique_subtopics.findIndex(x => {
            return x.subtopic_code == item.subtopic_code;
          }) < 0
        ) {
          unique_subtopics.push({
            category_id: item.category_id,
            category_name: item.category_name,
            category_name_e: item.category_name_e,
            subtopic_code: item.subtopic_code,
            subtopic_name: item.subtopic_name,
            subtopic_name_e: item.subtopic_name_e
          });
        }
      });
      return unique_subtopics;
    },
    getUniqueTopicsByCategoryIds(category_id) {
      const filtered_structure = this.report_structure.filter(
        item => item.category_id == category_id
      );
      const unique_topics = [];
      filtered_structure.forEach(item => {
        if (
          unique_topics.findIndex(x => {
            return x.topic_id == item.topic_id;
          }) < 0
        ) {
          unique_topics.push({
            category_id: item.category_id,
            category_name: item.category_name,
            category_name_e: item.category_name_e,
            topic_id: item.topic_id,
            topic_name: item.topic_name,
            topic_name_e: item.topic_name_e
          });
        }
      });
      return unique_topics;
    },
    navAnchor(anchor) {
      ih.anchorGo(anchor);
    }
  }
};
</script>

<style>
.content-section-compact-sub {
  min-width: 33%;
}

@media (max-width: 992px) {
  .content-section-compact,
  .content-section-compact-sub {
    width: auto;
  }
}

.custom-col {
  min-height: 20vh;
}
</style>
